/**
 * @file: 退款相关request
 */
import { request } from './request';
import { ApiConfigs, Response } from '../schemas/service';

const api: ApiConfigs = {
  applyRefund: {
    url: '/health/api/v1/order/applyRefund',
    method: 'POST'
  },
  refundProgress: {
    url: '/health/api/v1/order/refundProgress',
    method: 'GET'
  }
};

const patients = {
  async refundProgress(orderId) {
    try {
      const response: Response = await request(api.refundProgress, {
        orderId
      });
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async applyRefund({ orderId, refundReason }) {
    try {
      const response: Response = await request(api.applyRefund, {
        orderId,
        refundReason
      });
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default patients;
